import React from 'react';

export const ChevronRightGray300Icon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <mask
        id="mask0_6540_22818"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="8"
        y="4"
        width="9"
        height="15"
      >
        <path
          d="M8.30146 6.69902C7.90146 6.29902 7.90146 5.69902 8.30146 5.29902C8.50146 5.09902 8.70146 4.99902 9.00147 4.99902C9.30147 4.99902 9.50146 5.09902 9.70146 5.29902L15.7015 11.299C16.1015 11.699 16.1015 12.299 15.7015 12.699L9.70146 18.699C9.30146 19.099 8.70146 19.099 8.30146 18.699C7.90146 18.299 7.90146 17.699 8.30146 17.299L13.6015 11.999L8.30146 6.69902Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_6540_22818)">
        <rect width="24" height="24" fill="#DCDCDC" />
        <rect width="24" height="24" fill="#DCDCDC" />
      </g>
    </svg>
  );
};
